import type { z } from 'zod';
import { Api } from '@axiom/ui';
import type { CandidateOpportunity } from '@axiom/validation';
import { CandidateOpportunitySchema } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

const rejectCandidateOpportunityBodyType = CandidateOpportunitySchema.pick({
  candidateStatus: true,
  candidateStatusMessage: true,
  rejectionLossCode: true,
  rejectionLossCodeCustomMessage: true,
});

const coolCandidateOpportunityBodyType = CandidateOpportunitySchema.pick({
  candidateStatus: true,
  candidateStatusMessage: true,
});

class CandidateOpportunityApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async updateCandidateOpportunityRejection(
    candidateId: CandidateOpportunity['candidateId'],
    opportunityId: CandidateOpportunity['opportunityId'],
    body: z.infer<typeof rejectCandidateOpportunityBodyType>
  ) {
    return super.write<null>({
      endpoint: `/candidates/${candidateId}/opportunities/${opportunityId}/rejection`,
      method: 'PATCH',
      body,
    });
  }

  async updateCandidateOpportunityCooling(
    candidateId: CandidateOpportunity['candidateId'],
    opportunityId: CandidateOpportunity['opportunityId'],
    body: z.infer<typeof coolCandidateOpportunityBodyType>
  ) {
    return super.write<null>({
      endpoint: `/candidates/${candidateId}/opportunities/${opportunityId}/cooling`,
      method: 'PATCH',
      body,
    });
  }
}

export const CandidateOpportunityApi = new CandidateOpportunityApiClass();
